import Vue from 'vue'
import VModal from 'vue-js-modal'
import vSelect from 'vue-select'
import Pagination from 'vue-pagination-2';
import './components/js-component'
import './components/validate/validate'
import Components from './components/app'
import './customs'

Vue.component('v-select', vSelect)
Vue.component('pagination', Pagination);
Vue.use(VModal, { dynamic: true })
Vue.use(Components)
window.app = new Vue({
  el: '#app',
})



// WEBPACK FOOTER //
// ./src/js/main.js